export default __webpack_public_path__ + "static/media/logo-mobile.b349a4d0.svg";